import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';

const styles = require('./IncomingServerInformation.scss');

export interface IncomingAccountInformationProps {
    displayName?: string;
    emailAddress?: string;
    username?: string;
    password?: string;
    useNewFolder?: boolean;
    disableEmailAddress: boolean;
    renderUserNameContent: boolean;
    renderNewFolderContent: boolean;
    isBasicAuth: boolean;
    onUpdateDisplayName: (value: string) => void;
    onUpdateEmailAddress?: (value: string) => void;
    onUpdateUserName?: (value: string) => void;
    onUpdatePassword: (value: string) => void;
    onUpdateUseNewFolder?: (value: boolean) => void;
}

@observer
export default class IncomingAccountInformation extends React.Component<
    IncomingAccountInformationProps,
    {}
> {
    private onFolderSelectionChanged = (
        option: IChoiceGroupOption,
        evt?: React.FormEvent<HTMLElement | HTMLInputElement>
    ) => {
        let useNewFolder: boolean = option.key == 'NewFolder';
        this.props.onUpdateUseNewFolder(useNewFolder);
    };

    private renderUserNamePasswordContent = () => {
        return (
            this.props.isBasicAuth && (
                <div>
                    {this.props.renderUserNameContent && (
                        <TextField
                            className={styles.textbox}
                            label={strings.options_connected_advanced_altUserNameTextField}
                            onChanged={this.props.onUpdateUserName}
                        />
                    )}
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_basic_passwordTextField}
                        type="password"
                        onChanged={this.props.onUpdatePassword}
                        value={this.props.password}
                    />
                </div>
            )
        );
    };

    private renderTargetFolderContent = () => {
        return (
            this.props.renderNewFolderContent && (
                <ChoiceGroup
                    options={[
                        {
                            key: 'NewFolder',
                            text: strings.options_connected_basic_newFolderOption,
                            checked: this.props.useNewFolder,
                        },
                        {
                            key: 'ExistingFolder',
                            text: strings.options_connected_basic_existingFolderOption,
                            checked: !this.props.useNewFolder,
                        },
                    ]}
                    required={true}
                    label={strings.options_connected_basic_targetOptionLabel}
                    onChanged={this.onFolderSelectionChanged}
                />
            )
        );
    };

    render() {
        return (
            <div>
                <TextField
                    className={styles.textbox}
                    label={strings.options_connected_basic_displayNameTextField}
                    onChanged={this.props.onUpdateDisplayName}
                    value={this.props.displayName}
                />
                <TextField
                    className={styles.textbox}
                    label={strings.options_connected_basic_emailAddressTextField}
                    onChanged={this.props.onUpdateEmailAddress}
                    disabled={this.props.disableEmailAddress}
                    value={this.props.emailAddress}
                />
                {this.renderUserNamePasswordContent()}
                {this.renderTargetFolderContent()}
            </div>
        );
    }
}
